import ActionTypes from '../constants';

const initialState = {
    drivers: {},
    driver: {}
    // loading: false,
};

const driverReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETDRIVERSUCCESS:
            return {
                ...state,
                drivers: action.payload,
            }
        case ActionTypes.GETDRIVERBYIDSUCCESS:
            return {
                ...state,
                driver: action.payload,
            }
        default:
            return state;
    }
}

export default driverReducer;